import React from 'react'

const Wood = () => {
  return (
    <div className='Wood'>
        
    </div>
  )
}

export default Wood